var _text, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_16_1",
    "data-name": "Component 16 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 48.773,
    viewBox: "0 0 57 48.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Export",
    transform: "translate(0 43.773)",
    fill: "#a4a5a5",
    fontSize: 18,
    fontFamily: "Mulish-Bold, Mulish",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Export"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-export",
    "data-name": "Icon awesome-file-export",
    d: "M22.16,7.035a1.381,1.381,0,0,0-.4-.975L16.106.4a1.384,1.384,0,0,0-.981-.4h-.352V7.387H22.16ZM32.951,17.774l-5.523-5.563a.926.926,0,0,0-1.581.652V16.62H22.154v3.693h3.693v3.763a.926.926,0,0,0,1.581.652l5.523-5.569A.982.982,0,0,0,32.951,17.774ZM11.08,19.39V17.543A.926.926,0,0,1,12,16.62H22.16V9.233H14.312a1.389,1.389,0,0,1-1.385-1.385V0H1.385A1.382,1.382,0,0,0,0,1.385V28.162a1.382,1.382,0,0,0,1.385,1.385h19.39a1.382,1.382,0,0,0,1.385-1.385V20.313H12A.926.926,0,0,1,11.08,19.39Z",
    transform: "translate(15.695)",
    fill: "#a4a5a5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.11e1a62b97d1b10d21c2823554fa1c84.svg";
export { ForwardRef as ReactComponent };